// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-preview-container {
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);
}

.chat-preview-header {
  background: #114040;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 1rem;
}

.chat-preview-header span {
  color: var(--secondary-color);
  margin: 0;
  font-size: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  font-weight: 600;
  font-size: 1.8rem;
}

.chat-preview-messages {
  flex: 1 1;
  padding: 0.75rem;
  padding-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow-y: auto;
  background: rgba(42, 157, 143, 0.1);
}

.chat-message {
  max-width: 80%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  animation: messageSlideIn 0.5s ease forwards;
  opacity: 0;
}

.chat-message p {
  margin: 0;
  line-height: 1.4;
}

.chat-message.user {
  align-self: flex-end;
  background: #dcca98;
  color: #114040;
  animation-delay: 0.5s;
  margin: 0 0.5rem 0.5rem 0.5rem;
}

.chat-message.assistant {
  align-self: flex-start;
  background: white;
  color: #114040;
  animation-delay: 1.5s;
  margin: 0.5rem;
}

.chat-input {
  padding: 0.5rem 0.75rem;
  display: flex;
  gap: 0.5rem;
  background: rgba(42, 157, 143, 0.2);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.chat-input input {
  flex: 1 1;
  padding: 0.6rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: var(--secondary-color);
  font-size: 0.9rem;
}

.chat-input input::placeholder {
  color: rgba(220, 202, 152, 0.6);
}

.send-button {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: #264653;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.send-button:disabled {
  opacity: 0.7;
}

.send-icon {
  width: 20px;
  height: 20px;
  fill: var(--secondary-color);
}

@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Add a typing indicator animation */
.chat-message.assistant::after {
  content: '';
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-left: 8px;
  background: var(--secondary-color);
  border-radius: 50%;
  animation: typing 1s infinite;
}

@keyframes typing {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
} `, "",{"version":3,"sources":["webpack://./src/home/ChatPreview.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB","sourcesContent":[".chat-preview-container {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  width: 100%;\n  max-width: 500px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);\n}\n\n.chat-preview-header {\n  background: #114040;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  margin-bottom: 1rem;\n}\n\n.chat-preview-header span {\n  color: var(--secondary-color);\n  margin: 0;\n  font-size: 1.5rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  font-weight: 600;\n  font-size: 1.8rem;\n}\n\n.chat-preview-messages {\n  flex: 1;\n  padding: 0.75rem;\n  padding-bottom: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  overflow-y: auto;\n  background: rgba(42, 157, 143, 0.1);\n}\n\n.chat-message {\n  max-width: 80%;\n  padding: 0.75rem 1rem;\n  border-radius: 12px;\n  animation: messageSlideIn 0.5s ease forwards;\n  opacity: 0;\n}\n\n.chat-message p {\n  margin: 0;\n  line-height: 1.4;\n}\n\n.chat-message.user {\n  align-self: flex-end;\n  background: #dcca98;\n  color: #114040;\n  animation-delay: 0.5s;\n  margin: 0 0.5rem 0.5rem 0.5rem;\n}\n\n.chat-message.assistant {\n  align-self: flex-start;\n  background: white;\n  color: #114040;\n  animation-delay: 1.5s;\n  margin: 0.5rem;\n}\n\n.chat-input {\n  padding: 0.5rem 0.75rem;\n  display: flex;\n  gap: 0.5rem;\n  background: rgba(42, 157, 143, 0.2);\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.chat-input input {\n  flex: 1;\n  padding: 0.6rem 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--secondary-color);\n  font-size: 0.9rem;\n}\n\n.chat-input input::placeholder {\n  color: rgba(220, 202, 152, 0.6);\n}\n\n.send-button {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: none;\n  background: #264653;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.send-button:disabled {\n  opacity: 0.7;\n}\n\n.send-icon {\n  width: 20px;\n  height: 20px;\n  fill: var(--secondary-color);\n}\n\n@keyframes messageSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Add a typing indicator animation */\n.chat-message.assistant::after {\n  content: '';\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-left: 8px;\n  background: var(--secondary-color);\n  border-radius: 50%;\n  animation: typing 1s infinite;\n}\n\n@keyframes typing {\n  0%, 100% { opacity: 0.3; }\n  50% { opacity: 1; }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
